export interface ParceiroDTO {
  id: number;
  nome: string;
  hotsite: string;
  abrangencia_nacional: string;
  descricao: string;
  beneficio: string;
  beneficio_utilizacao: string;
  categoria: ParceiroCategoriaDTO[];
  imagens: {
    logo: string;
    bg_hotsite: string;
  };
}

export interface ParceiroCategoriaDTO {
  id: number;
  nome: string;
}

export const parceiroCategorias = [
  'ACADEMIAS',
  'ALIMENTAÇÃO',
  'ANIMAIS',
  'AUTOS',
  'COMBUSTÍVEIS',
  'COMÉRCIO',
  'COMUNICAÇÃO',
  'EDUCAÇÃO',
  'INFORMÁTICA',
  'LAZER',
  'ONLINE',
  'PARA SUA CASA',
  'PLANOS E SEGUROS',
  'SAÚDE',
  'SERVIÇOS',
];

export interface ParceiroUnidadesDTO {
  total: number;
  unidades: UnidadeDTO[];
}

export interface EstadosParceirosDTO {
  id: number;
  uf: string;
  nome: string;
}

export interface CidadeParceirosDTO {
  id: number;
  nome: string;
}

export interface UnidadeDTO {
  id: number;
  nome: string;
  url: string;
  facebook: string;
  telefones: string[];
  endereco: {
    id: string;
    resumo: string;
    geolocalizacao: {
      latitude: string;
      longitude: string;
    };
    cep: string;
    estado: {
      id: number;
      uf: string;
      nome: string;
    };
    cidade: {
      id: number;
      nome: string;
    };
    bairro: {
      id: number;
      nome: string;
    };
    logradouro: string | null;
    numero: string | null;
    atualizado_em: number;
  };
}
